module.exports = __webpack_public_path__ + "img/social_friend_inactive.8ee04d0d.svg";